import { CompSelectionProperty } from '../types.ts';
import { calcQualityTier } from '../internal/qualityTier/calcQualityTier.ts';

export function addQualityTiers(properties: CompSelectionProperty[]) {
  const qualityTierProperties = calcQualityTier(properties);
  properties.forEach((p) => {
    const qualityTierProperty = qualityTierProperties.find((sp) => sp.id === p.id);
    if (qualityTierProperty) {
      p.qualityTier = qualityTierProperty.qualityTier;
    }
  });
}
